module.exports = __webpack_public_path__ + "static/media/freq_strip.a6f3c8bc.png";